import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-OutdoorDevice",
  "use": "svg-icon-OutdoorDevice-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-OutdoorDevice\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm9.5 1.539h-9v6.923h9V1.539zM5 7l3-2-3-2v4zm-1.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol